module.exports = __webpack_public_path__ + "static/media/ALZ-MONVA.970f76e5.jpg";